import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "visibleFilter" })
export class VisibleFilterPipe implements PipeTransform {
	transform(items: unknown[], ...args: unknown[]): unknown {
		const filterActive = args[0];
		if (!items || !filterActive) {
			return items;
		}

		return items.filter((item, index, allItems) => {
			if (allItems.length < 3) {
				return item;
			} else if (index < 2) {
				return item;
			} else if (index === allItems.length - 1) {
				return item;
			}
			return items;
		});
	}
}
